/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_PipelineInputs */

const en_reference_field_pipeline = /** @type {(inputs: Reference_Field_PipelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pipeline`)
};

/**
* | output |
* | --- |
* | "Pipeline" |
*
* @param {Reference_Field_PipelineInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_pipeline = /** @type {((inputs?: Reference_Field_PipelineInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_PipelineInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_pipeline(inputs)
});